import { render } from "./AdvertisementPage.vue?vue&type=template&id=45c51ff5&scoped=true"
import script from "./AdvertisementPage.vue?vue&type=script&lang=js"
export * from "./AdvertisementPage.vue?vue&type=script&lang=js"

import "./AdvertisementPage.vue?vue&type=style&index=0&id=45c51ff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c51ff5"]])

export default __exports__